import { render } from "./PlotStatements.vue?vue&type=template&id=6ba8790a&scoped=true"
import script from "./PlotStatements.vue?vue&type=script&lang=js"
export * from "./PlotStatements.vue?vue&type=script&lang=js"

import "./PlotStatements.vue?vue&type=style&index=0&id=6ba8790a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ba8790a"]])

export default __exports__